import React from 'react';
import { Terminal, Heart } from 'lucide-react';
import { personalInfo } from '../mock';
import { useTheme } from '../context/ThemeContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { theme } = useTheme();

  const footerLinks = [
    { label: 'About', href: '#about' },
    { label: 'Skills', href: '#skills' },
    { label: 'Experience', href: '#experience' },
    { label: 'Projects', href: '#projects' },
    { label: 'Contact', href: '#contact' }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className={`border-t py-12 px-4 sm:px-6 lg:px-8 ${
      theme === 'dark' 
        ? 'bg-[#1B3139] border-white/10' 
        : 'bg-gray-50 border-gray-200'
    }`}>
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <Terminal className="h-6 w-6 text-[#FF3621]" />
              <span 
                className={`font-bold text-xl ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                {personalInfo.name.split(' ').map(n => n[0]).join('')}
              </span>
            </div>
            <p 
              className={`text-sm leading-relaxed ${theme === 'dark' ? 'text-white/60' : 'text-gray-600'}`}
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              Making Data & AI simpler, approachable, and impactful for everyone.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 
              className={`font-bold mb-4 text-sm uppercase tracking-wider ${
                theme === 'dark' ? 'text-white' : 'text-gray-900'
              }`}
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              Quick Links
            </h3>
            <ul className="space-y-2">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className={`hover:text-[#FF3621] transition-colors text-sm ${
                      theme === 'dark' ? 'text-white/60' : 'text-gray-600'
                    }`}
                    style={{ fontFamily: 'DM Sans, sans-serif' }}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 
              className={`font-bold mb-4 text-sm uppercase tracking-wider ${
                theme === 'dark' ? 'text-white' : 'text-gray-900'
              }`}
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              Contact
            </h3>
            <div className="space-y-2">
              <p 
                className={`text-sm ${theme === 'dark' ? 'text-white/60' : 'text-gray-600'}`}
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                {personalInfo.email}
              </p>
              <p 
                className={`text-sm ${theme === 'dark' ? 'text-white/60' : 'text-gray-600'}`}
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                {personalInfo.location}
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className={`pt-8 border-t ${theme === 'dark' ? 'border-white/10' : 'border-gray-200'}`}>
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p 
              className={`text-sm flex items-center ${theme === 'dark' ? 'text-white/40' : 'text-gray-500'}`}
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              © {currentYear} {personalInfo.name}. Built with <Heart className="h-4 w-4 text-[#FF3621] mx-1 fill-current" /> and Databricks inspiration.
            </p>
            <p 
              className={`text-xs font-mono ${theme === 'dark' ? 'text-white/40' : 'text-gray-500'}`}
              style={{ fontFamily: 'DM Mono, monospace' }}
            >
              Powered by React + FastAPI
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
